import Link from "next/link"
import Image from "components/Image"
import { getStoryblokLink } from "utilities/getStoryblokLink"
import richText from "utilities/richText"

export default function AffiliateCard({ blok }) {
  return (
    <section className="my-6 px-8 first:mt-12 last:mb-12">
      <div className="mx-auto flex max-w-screen-lg flex-col gap-6 rounded-10 bg-white p-6 shadow sm:gap-12 md:flex-row lg:p-10">
        <Image
          src={blok.image.filename}
          alt={blok.image.alt}
          width={240}
          height={240}
          className="max-h-56 w-full self-start object-contain sm:max-h-full md:basis-1/2 lg:basis-1/4"
        />
        <div className="md:basis-1/2 lg:basis-3/4">
          {blok?.title ? <h2 className="pb-4 text-teal-dark">{blok.title}</h2> : null}
          <div className="pb-4">{richText(blok.content)}</div>
          {blok?.link && blok?.link_label ? (
            <Link
              href={getStoryblokLink(blok.link)}
              className="text-m1 font-bold text-teal-dark underline hover:no-underline"
            >
              {blok.link_label}
            </Link>
          ) : null}
        </div>
      </div>
    </section>
  )
}
